module.exports = __webpack_public_path__ + "static/media/bcsgLogo.8ade9386.png";